import { render, staticRenderFns } from "./MainCOPY.vue?vue&type=template&id=19456c9e&scoped=true&"
import script from "./MainCOPY.vue?vue&type=script&lang=js&"
export * from "./MainCOPY.vue?vue&type=script&lang=js&"
import style0 from "./MainCOPY.vue?vue&type=style&index=0&id=19456c9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19456c9e",
  null
  
)

export default component.exports